<template>
  <basic-container>
    <el-form :model="searchForm" ref="searchFormRef" label-width="100px" label-suffix=":" v-show="searchBoxFlag">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="服务网点" prop="nursinghomeId">
            <el-select v-model="searchForm.nursinghomeId" style="width: 100%" placeholder="项目名称"
              @change="nursinghomeIdChange">
              <el-option v-for="item in nursinghomeIdList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="老人姓名" prop="name">
            <el-input clearable v-model="searchForm.name" placeholder="老人姓名" maxlength="16"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="searchForm.sex" style="width: 100%" placeholder="性别">
              <el-option v-for="item in sexList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="身份证号" prop="idNumber">
            <el-input clearable v-model="searchForm.idNumber" placeholder="身份证号" maxlength="30"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="老人分类" prop="categoryTagList">
            <el-select v-model="searchForm.categoryTagList" multiple placeholder="老人分类" style="width:100%">
              <el-option v-for="item in categoryTagsList" :key="item.dictKey" :label="item.dictValue"
                :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item label="服务需求" prop="serviceNeedTagList">
            <el-select v-model="searchForm.serviceNeedTagList" multiple placeholder="服务需求" style="width:100%">
              <el-option v-for="item in needTagsList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入住状态" prop="occupancyStatus">
            <el-select v-model="searchForm.occupancyStatus" clearable placeholder="入住状态" style="width:100%">
              <el-option v-for="item in occupancyStatusList" :key="item.dictKey" :label="item.dictValue"
                :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="合同签订状态" prop="isContract">
            <el-select v-model="searchForm.isContract" clearable placeholder="合同签订状态" style="width:100%">
              <el-option v-for="item in isContractList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生存状态" prop="isExistence">

            <el-select clearable v-model="searchForm.isExistence" style="width: 100%" placeholder="生存状态">
              <el-option v-for="item in isExistenceList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>

          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="死亡日期" prop="daterange">
            <el-date-picker v-model="searchForm.deathRange" style="width: 100%;" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入住日期" prop="daterange">
            <el-date-picker v-model="searchForm.signInRange" style="width: 100%;" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="合同到期日期" prop="daterange">
            <el-date-picker v-model="searchForm.contractRange" style="width: 100%;" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
            <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud :option="option" :table-loading="loading" :data="data" :page.sync="page" ref="crud" @on-load="onLoad"
      @current-change="currentChange" @size-change="sizeChange" @refresh-change="onLoad"
      @selection-change="selectionChange" @cell-click="cellClick"
        :cell-style="cellStyle">
      <template slot="menuRight">
        <searchFromShow :searchBoxFlag.sync="searchBoxFlag" :removeHeight="searchHeight" :option="option"
          reduceHeight="20" :refOption="$refs.crud"></searchFromShow>
      </template>

      <template slot="menuLeft">
        <el-button type="primary" size="small" v-if="permissionList.addBtn" @click="addNursingForm"> 新 增</el-button>
        <el-button type="primary" size="small" v-if="permissionList.importBtn" icon="el-icon-upload2" plain
          @click="handleImport">导 入
        </el-button>
        <el-button type="primary" size="small" v-if="permissionList.exportBtn" icon="el-icon-plus"
          @click="exportExcel()">导 出
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <!-- <el-button type="text" size="small" v-if="permissionList.viewBtn" @click="viewFun(scope.row)">查看 </el-button> -->
        <el-button type="text" size="small" v-if="permissionList.editBtn" @click="editRecord(scope.row)">编辑 </el-button>
        <el-button type="text" size="small" v-if="permissionList.delBtn" @click="deleteFun(scope.row.id)">删除
        </el-button>
        <el-button type="text" size="small" v-if="permissionList.signBtn && scope.row.isContract == '0' && scope.row.isExistence == '1'" @click="sign(scope.row)">签约 </el-button>
        <el-button type="text" size="small" v-if="permissionList.moveBtn && scope.row.isContract == '1' && scope.row.occupancyStatus != '1' && scope.row.bedId  && scope.row.isExistence == '1'" @click="moveInto(scope.row)">入住 </el-button>
        <el-button type="text" size="small" v-if="permissionList.refundBtn && scope.row.isContract == '1' && scope.row.isExistence == '1'" @click="refund(scope.row)">退约 </el-button>
        <el-button type="text" size="small" v-if="permissionList.renewBtn && scope.row.isContract == '1'&& scope.row.isExistence == '1'"" @click="renew(scope.row)">续约 </el-button>
      </template>
    </avue-crud>

    <itemList ref="itemList"></itemList>
    <hr-dialog :title="formModel === 'add' ? '新增' : formModel === 'edit' ? '编辑' : '查看'" :allowFull="false" width="60%"
      @close="closeAddOldManDialog" :visible.sync="nursingFormVisible">
      <template slot="body">
        <peopleForm :model="formModel" :row="formRow" @cancle="recordCancle" v-if="nursingFormVisible"
          @success="recordSuccess" @stepsuccess="onLoad" :nursinghomeId="this.searchForm.nursinghomeId"
          :nursinghomeName="this.searchForm.nursinghomeName"></peopleForm>
      </template>
    </hr-dialog>

    <hr-dialog :title="dialogTitle" :allowFull="false" :width="formModel == 'move' ? '30%' : '60%'"
      :visible.sync="dialogVisible" @close="closeDialog">
      <template slot="body">
        <RefundForm :row="formRow" :isContract="true" @cancle="signCancle" v-if="dialogVisible && formModel == 'refund'"
          @success="signSuccess"></RefundForm>
        <MoveForm :row="formRow" @cancle="signCancle" v-if="dialogVisible && formModel == 'move'"
          @success="signSuccess"></MoveForm>
        <signForm :model="formModel" :isContract="true" :row="formRow" @cancle="signCancle" v-if="dialogVisible && (formModel == 'sign' || formModel == 'renew')" @success="signSuccess">
        </signForm>
      </template>
    </hr-dialog>

    <el-dialog width="400px" :visible.sync="isImportDialogShow" :append-to-body="true" :close-on-click-modal="false">
      <ImportFile v-if="isImportDialogShow" title="安康通导入" exportApi="/api/nursing/basicInfor/exportTemplate"
        importApi="/api/nursing/basicInfor/importBasicInfor" @uploadCallBack="importCallBack"></ImportFile>
    </el-dialog>
  </basic-container>
</template>
<script>
import { getnursinghomeIdList } from '@/api/crmedical/project/project';
import { basicInforRemove, getNursinghomePage, getNursinghome, stockWarnPage, getWarehouseList, stockWarnDelete } from '../api/serveItemManage.js';
import ImportFile from '@/views/nursingHome/initData/importFile';

import searchFromShow from '@/components/search-form-show/index';
import peopleForm from './peopleForm.vue';
import signForm from './components/signForm.vue';
import RefundForm from './components/refundForm.vue';
import MoveForm from './components/moveForm.vue';
import { getDictionary } from '@/api/common.js';
// import { removeStore } from '@/util/store';
import { removeStore, getStore } from '@/util/store';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
export default {
  components: { searchFromShow, peopleForm, signForm, RefundForm, MoveForm, ImportFile },
  data() {
    return {
      dialogTitle: '',
      dialogVisible: false,
      isImportDialogShow: false,
      isExistenceList: [
        {
          id: 1,
          name: '在世'
        },
        {
          id: 0,
          name: '死亡'
        }
      ],
      isContractList: [
        {
          id: '1',
          name: '是'
        },
        {
          id: '0',
          name: '否'
        }
      ],
      editVisible: false,
      formModel: 'add',
      isImportDialogShow: false,
      settingTotalWarnVisible: false,
      nursingFormVisible: false,
      printVisible: false,
      addOrderVisible: false,
      alarmRuleVisible: false,
      alarmRuleTittle: '编辑',
      alarmRuleModel: 'view',
      rowInfo: {},
      searchForm: {
        nursinghomeId: '',
        name: '',
        sex: '',
        idNumber: '',
        occupancyStatus: "",
        consumableName: '',
        specification: '',

        categoryTagList: [],
        serviceNeedTagList: [],
        deathRange: [],
        contractRange: [],
        signInRange: [],
      },

      nursinghomeIdList: [],

      option: {
        selection: false,
        select: true,
        index: true,
        indexLabel: '#',
        page: true,
        height: 'auto',
        calcHeight: 'auto',
        align: 'left',
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [

          {
            label: '老人姓名',
            prop: 'name',
          },
          {
            label: '性别',
            prop: 'sex',
            dicUrl: '/api/blade-system/dict/dictionary?code=sex',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '年龄',
            prop: 'age',
          },
          {
            label: '身份证号码',
            prop: 'idNumber',
            width: 150,
          },
          {
            label: '联系电话',
            prop: 'tel',
            width: 150,
          },
          {
            label: '生存状态',
            prop: 'isExistence',
            type: 'select',
            dataType: 'number',
            dicData: [
              {
                id: 1,
                name: '在世'
              },
              {
                id: 0,
                name: '死亡'
              }
            ],
            props: {
              label: 'name',
              value: 'id',
            },
          },
          {
            label: '老人分类',
            prop: 'categoryTagStr',
            width: 150,
          },
          {
            label: '服务需求',
            prop: 'serviceNeedTagStr',
            width: 150,
          },
          {
            label: '家庭住址',
            prop: 'addressIdName',
            width: 200,
            overHidden: true,
          },
          {
            label: '详细地址',
            prop: 'address',
            width: 200,
            overHidden: true,
          },
          {
            label: '是否签约',
            prop: 'isContract',
            dicData: [
              {
                id: '1',
                name: '是'
              },
              {
                id: '0',
                name: '否'
              }
            ],
            props: {
              label: 'name',
              value: 'id',
            },
          },
          {
            label: '入住状态',
            prop: 'occupancyStatus',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_occupancy_status_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '入住日期',
            prop: 'signInTime',
            width: 100,
          },
          {
            label: '床位',
            prop: 'bedName',
          },
          {
            label: '实际总收费',
            prop: 'realFeeTotal',
            width: 100,
          },
          {
            label: '健康总分值',
            prop: 'healthScore',
            width: 100,
          },
          {
            label: '合同到期日期',
            prop: 'contractExpirationTime',
            width: 100,
          },
          {
            label: '退约日期',
            prop: 'leaveDate',
            width: 100,
          },
          {
            label: '退约原因',
            prop: 'leaveReason',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursing_leave_reason',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            width: 150,
          },
          {
            label: '死亡日期',
            prop: 'deathTime',
            width: 100,
          },
          {
            label: '档案号',
            prop: 'fileNumber',
          },
          {
            label: '所属服务网点',
            prop: 'nursinghomeId',
            width: 150,
            dicUrl: '/api/nursing/getNursinghome',
            props: {
              label: 'name',
              value: 'id',
            },
          },
          // {
          //   label: '登记入住时间',
          //   type: 'date',
          //   format: 'yyyy-MM-dd',
          //   prop: 'signInTime',
          // },
          // {
          //   label: '出院时间',
          //   type: 'date',
          //   format: 'yyyy-MM-dd',
          //   prop: 'dischargeTime',
          // },
          // {
          //   label: '签订合同时间',
          //   prop: 'signContractTime',
          // },
          // {
          //   label: '经办人',
          //   prop: 'responsiblePersonStr',
          // },
        ],
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      loading: false,
      searchBoxFlag: true,
      searchHeight: '',
      selectionList: [],
      recordIds: [],
      canteenList: [],
      warehouseList: [],
      selectionIds: '',
      formRow: {},
      sexList: [],
      politicList: [],
      politicalFeaturesList: [],
      categoryTagsList: [],
      needTagsList: [],
      occupancyStatusList: [],
    };
  },
  created() {
    this.initData();
  },
  computed: {

    ...mapGetters(['permission']),
    permissionList() {
      return {
        viewBtn: this.vaildData(this.permission.oldman_view, false),
        addBtn: this.vaildData(this.permission.oldman_add, false),
        editBtn: this.vaildData(this.permission.oldman_edit, false),
        delBtn: this.vaildData(this.permission.oldman_delete, false),
        importBtn: this.vaildData(this.permission.oldman_import, false),
        exportBtn: this.vaildData(this.permission.oldman_export, false),
        signBtn: this.vaildData(this.permission.oldman_sign, false),
        moveBtn: this.vaildData(this.permission.oldman_move, false),
        refundBtn: this.vaildData(this.permission.oldman_refund, false),
        renewBtn: this.vaildData(this.permission.oldman_renew, false),
      };
    },

  },
  mounted() {
    this.calcHeight();
    let self = this;
    self.$refs.crud.doLayout();
    window.onresize = () => {
      self.$refs.crud.doLayout();
    }
  },
  activated() {
    console.log('activated=======================');
    this.$refs.crud.doLayout();
  },
  methods: {
    closeAddOldManDialog() {
      removeStore({
        name: 'elderId'
      });
    },
    closeDialog() {
      this.dialogTitle = ''
      this.formModel = '';
      this.formRow = {};
      this.dialogVisible = false;
    },
    openItemDetail(row) {
      this.$refs.itemList.openItemListOnload(row.id, row.name);
    },
    addNursingForm() {
      removeStore({
        name: 'elderId'
      });
      this.formModel = 'add';
      this.formRow = {
        nursinghomeId: this.searchForm.nursinghomeId,
        nursinghomeName: this.searchForm.nursinghomeName,
      };
      this.nursingFormVisible = true;
    },
    importSuccess() {
      this.isImportDialogShow = false;
      this.onLoad();
    },

    deleteFun(id) {
      this.$confirm(' 是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          basicInforRemove(id).then((re) => {
            this.$message.success('删除成功');
            this.onLoad();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },

    editRecord(row) {
      this.formModel = 'edit';
      this.formRow = row;
      this.nursingFormVisible = true;
    },
    viewFun(row) {
      this.formModel = 'view';
      this.formRow = row;
      this.nursingFormVisible = true;
    },
    sign(row) {
      this.dialogTitle = '签约'
      this.formModel = 'sign';
      this.nursinghomeIdList.forEach(ele => {
        if (row.nursinghomeId === ele.id) {
          row.nursinghomeName = ele.name;
        }
      });
      this.formRow = row;
      this.dialogVisible = true;
    },
    moveInto(row, data) {
      this.dialogTitle = '入住'
      this.formModel = 'move';
      row.bedName = data ? data.bedName : row.bedName
      this.formRow = row;
      this.dialogVisible = true;
    },
    refund(row) {
      this.dialogTitle = '退约'
      this.formModel = 'refund';
      this.formRow = row;
      this.dialogVisible = true;
    },
    renew(row) {
      this.dialogTitle = '续约'
      this.formModel = 'renew';
      this.formRow = row;
      this.dialogVisible = true;
    },
    handleImport() {
      this.isImportDialogShow = true
    },
    exportExcel() {
      this.$confirm('是否导数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出数据
        // 将条件参数拼接为路由传参格式
        let paramFormString = this.tool.objToform(this.searchForm);
        //
        this.tool.downloadFile(
          `/api/nursing/basicInfor/exportBasicInfor?${this.website.tokenHeader
          }=${getToken()}&${paramFormString}`,
          'abc.xlsx',
          'xlsx/xls'
        );
      });
    },
    settingTotalWarn() {
      this.formModel = 'add';
      this.settingTotalWarnVisible = true;
    },
    importFun() {
      this.isImportDialogShow = true;
    },
    nursingForm() {
      this.formModel = 'add';
      this.nursingFormVisible = true;
    },

    recordCancle() {
      removeStore({
        name: 'elderId'
      });
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
    },
    recordSuccess() {
      this.editVisible = false;
      this.nursingFormVisible = false;
      this.settingTotalWarnVisible = false;
      this.onLoad();
    },
    signSuccess(val, data) {
      console.log(val);
      if (val == 'toMove') {
        this.moveInto(this.formRow, data)
        this.onLoad();
      } else {
        this.dialogVisible = false;
        this.dialogTitle = ''
        this.onLoad();
      }

    },
    signCancle() {
      this.dialogTitle = ''
      this.dialogVisible = false;
    },
    /* 导入成功的回调 */
    importCallBack(ret) {
      if (ret) {
        this.isImportDialogShow = false;
        this.onLoad();
      }
    },
    viewRecord(row) {
      this.alarmRuleTittle = '查看';
      this.rowInfo = row;

      this.alarmRuleModel = 'view';
      this.alarmRuleVisible = true;
    },

    addRecord() {
      this.alarmRuleTittle = '新增';
      this.alarmRuleVisible = true;
      this.rowInfo = {
        nursinghomeId: this.searchForm.nursinghomeId,
      };
      this.alarmRuleModel = 'add';
    },

    stopCanteen() {
      this.alarmRuleVisible = true;
    },
    nursinghomeIdChange(nursinghomeId) {
      this.searchForm.warehouseId = '';
      this.warehouseList = [];
      getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
        this.warehouseList = res.data;
      });
      let self = this;
      this.nursinghomeIdList.forEach(ele => {
        if (nursinghomeId === ele.id) {
          self.searchForm.nursinghomeName = ele.name;
        }
      });
      // //  getCanteenName({nursinghomeId:nursinghomeId}).then(res=>{
      // //           this.canteenList = res.data
      // //        })
      // this.getDeptList(this.searchForm.nursinghomeId);
      // this.getCanteen(this.searchForm.nursinghomeId);
    },
    searchRecord() {
      this.page.currentPage = 1;
      if (this.searchForm.deathRange && this.searchForm.deathRange.length > 0) {
        this.searchForm.deathTimeSearchStart = this.dayjs(this.searchForm.deathRange[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.deathTimeSearchEnd = this.dayjs(this.searchForm.deathRange[1]).format(
          'YYYY-MM-DD 23:59:59'
        );
      } else {
        this.searchForm.deathTimeSearchStart = '';
        this.searchForm.deathTimeSearchEnd = '';
      }
      if (this.searchForm.contractRange && this.searchForm.contractRange.length > 0) {
        this.searchForm.contractExpirationTimeSearchStart = this.dayjs(this.searchForm.contractRange[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.contractExpirationTimeSearchEnd = this.dayjs(this.searchForm.contractRange[1]).format(
          'YYYY-MM-DD 23:59:59'
        );
      } else {
        this.searchForm.contractExpirationTimeSearchStart = '';
        this.searchForm.contractExpirationTimeSearchEnd = '';
      }
      if (this.searchForm.signInRange && this.searchForm.signInRange.length > 0) {
        this.searchForm.signInTimeSearchStart = this.dayjs(this.searchForm.signInRange[0]).format(
          'YYYY-MM-DD 00:00:00'
        );
        this.searchForm.signInTimeSearchEnd = this.dayjs(this.searchForm.signInRange[1]).format(
          'YYYY-MM-DD 23:59:59'
        );
      } else {
        this.searchForm.signInTimeSearchStart = '';
        this.searchForm.signInTimeSearchEnd = '';
      }
      this.onLoad();
    },
    searchClear() {
      this.tool.clearObject(this.searchForm, 'nursinghomeId');
      this.searchForm.type = '0';
    },

    calcHeight() {
      this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
      this.option.height = this.bodyHeight - this.searchHeight - 279 - 20;
    },
    initData() {
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
        if (this.nursinghomeIdList.length > 0) {
          this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
          this.$set(this.searchForm, 'nursinghomeName', this.nursinghomeIdList[0].name);
          // getWarehouseList({ nursinghomeId: this.searchForm.nursinghomeId }).then((res) => {
          //   this.warehouseList = res.data;
          // });
          console.log("onLoad==============>");
          this.onLoad();
        }
      });
      getDictionary('nursinghome_occupancy_status_type').then((res) => {
        this.occupancyStatusList = res.data;
      })
      getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
      });
      getDictionary('nursinghome_elderly_category_tag').then((res) => {
        this.categoryTagsList = res.data;
      })
      getDictionary('nursinghome_service_need_tag').then((res) => {
        this.needTagsList = res.data;
      })
      getDictionary("sex").then(res => {
        this.sexList = res.data
      })
      getDictionary("nursinghome_political_features_type").then(res => {
        this.politicalFeaturesList = res.data
      })

    },

    cellClick(row, column) {
      if (column.label === '老人姓名') {
        console.log(row);
        if (row.name) {
          this.formModel = 'view';
          this.formRow = row;
          this.nursingFormVisible = true;
        }
      }
    },
    cellStyle({column}) {
      if (column.label === '老人姓名') {
        return {
          color: '#409eff',
          cursor: 'pointer',
        };
      }
    },

    onLoad() {
      if (this.searchForm.nursinghomeId != '') {
        this.loading = true;

        let obj = Object.assign({}, this.searchForm);
        console.log(obj)
        if (obj.categoryTagList && obj.categoryTagList.length > 0) {
          obj.categoryTags = obj.categoryTagList.join(",");
        }
        if (obj.serviceNeedTagList && obj.serviceNeedTagList.length > 0) {
          obj.serviceNeedTags = obj.serviceNeedTagList.join(",");
        }

        delete obj.serviceNeedTagList
        delete obj.categoryTagList
        getNursinghomePage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            obj
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.data.forEach(ele => {
              ele.contractExpirationTime = ele.contractExpirationTime ? ele.contractExpirationTime.split(' ')[0] : '';
              ele.signInTime = ele.signInTime ? ele.signInTime.split(' ')[0] : '';
              ele.deathTime = ele.deathTime ? ele.deathTime.split(' ')[0] : '';
              ele.leaveDate = ele.leaveDate ? ele.leaveDate.split(' ')[0] : '';
            });
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .avue-crud__right {
  display: flex;
}

::v-deep .el-drawer__body {
  overflow: scroll !important;
}

::v-deep .avue-crud .el-form-item {
  display: block;
}

.money {
  text-align: right;
}

.txtOver {
  display: -webkit-box;
  overflow: hidden;
  /*超出隐藏*/
  text-overflow: ellipsis;
  /*隐藏后添加省略号*/
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
<style>
#alarmRule>div>div.el-dialog__body {
  height: calc(100% - 100px);
}
</style>
